module.exports = __webpack_public_path__ + "static/img/EG.acbe01f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/company-logo/EG.png
// module id = S5yZ
// module chunks = 34